import React, { useEffect, useRef, useState } from 'react';
import SalesInsights from './Components/SalesInsights/SalesInsights';
import ProductAndInventoryInsights from './Components/ProductAndInventoryInsights/ProductAndInventoryInsights';
import ChevronDown from '../../Assets/Dropdown/ChevronDown.svg';
import CouponInsights from './Components/CouponInsights/CouponInsights';
import LensInsights from './Components/LensInsights/LensInsights';
import { useDispatch, useSelector } from 'react-redux';
import { changeReportRange, changeTab, fetchCouponsInsights, fetchLensInsights, fetchProductsInsights, fetchSalesInsights } from '../../Features/reportAnalysisSlice';
import TabButton from '../../Components/TabButton/TabButton';
import { useOutsideClickForTwoRef } from '../../Hooks/useOutsideClickForTwoRef';

function ReportAndAnalyticsPage() {
    const dispatch = useDispatch();
    const activeTab = useSelector((state) => state.reportAnalysis.activeTab);
    const reportRange = useSelector((state) => state.reportAnalysis.reportRange);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dropdownButtonRef = useRef(null);

    useOutsideClickForTwoRef(dropdownButtonRef, dropdownRef, () => {
        setDropdownOpen(false);
    });

    const updateActiveTab = (selection) => {
        dispatch(changeTab(selection));
    }

    function updateReportRange(range) {
        dispatch(changeReportRange(range));
    }

    useEffect(() => {
        dispatch(fetchSalesInsights());
        dispatch(fetchProductsInsights());
        dispatch(fetchCouponsInsights());
        dispatch(fetchLensInsights());
        // eslint-disable-next-line
    }, []);

    return (
        <div className="w-full overflow-y-scroll pb-16 outline-none">
            <div className="flex items-center justify-between gap-6 m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl">Report and Analytics</h1>

                <div className="flex gap-4 select-none">
                    {/* <button onClick={() => {}} className='bg-primaryColor hover:bg-primaryAccent rounded-md px-3 py-[10px] text-buttonText font-semibold text-[14px] leading-[22px]'>
                        Download Report
                    </button> */}

                    <div ref={dropdownButtonRef} onClick={() => setDropdownOpen(!dropdownOpen)} className="relative cursor-pointer rounded-md border border-[#EAEAEA] p-[10px_2px_10px_8px] flex items-center gap-1">
                        <p className='w-20 font-semibold text-[14px] leading-[22px] text-[#121212] text-left whitespace-nowrap'>
                            {
                                reportRange === 'allTime' ? 'All time' : 
                                reportRange === 'lastMonth' ? 'Last 30 days' :
                                reportRange === 'lastWeek' ? 'Last 7 days' : ''
                            }
                        </p>

                        <div className="size-[22px] flex items-center justify-center">
                            <img src={ChevronDown} alt="" />
                        </div>

                        {
                            dropdownOpen && 
                            <div ref={dropdownRef} className="z-10 absolute top-11 left-0 w-full shadow-[0px_0px_12px_0px_#0000003D] font-semibold rounded-[5px] text-left overflow-hidden">
                                <p onClick={() => updateReportRange('allTime')} className='px-2 py-[10px] text-[14px] leading-[22px] bg-[#FFFFFF] hover:bg-[#F5F5F5]'>All time</p>

                                <p onClick={() => updateReportRange('lastWeek')} className='px-2 py-[10px] text-[14px] leading-[22px] bg-[#FFFFFF] hover:bg-[#F5F5F5]'>Last 7 days</p>

                                <p onClick={() => updateReportRange('lastMonth')} className='px-2 py-[10px] text-[14px] leading-[22px] bg-[#FFFFFF] hover:bg-[#F5F5F5]'>Last 30 days</p>
                            </div>
                        }
                    </div>
                </div>
            </div>

            <div className="flex border-b-2 border-[#F5F5F5] m-[0px_19px_0px_20px]">
                <TabButton 
                    id='sales' 
                    optionName='Sales Insights' 
                    selected={activeTab} 
                    handleSelect={updateActiveTab} 
                />
                <TabButton 
                    id='inventory' 
                    optionName='Product & Inventory Insights' 
                    selected={activeTab} 
                    handleSelect={updateActiveTab} 
                />
                <TabButton 
                    id='coupons' 
                    optionName='Coupon Insights' 
                    selected={activeTab} 
                    handleSelect={updateActiveTab} 
                />
                <TabButton 
                    id='lens' 
                    optionName='Lens Insights' 
                    selected={activeTab} 
                    handleSelect={updateActiveTab} 
                />
            </div>

            <div className="flex flex-col">
                {activeTab === 'sales' && <SalesInsights />}

                {activeTab === 'inventory' && <ProductAndInventoryInsights />}

                {activeTab === 'coupons' && <CouponInsights />}

                {activeTab === 'lens' && <LensInsights />}
            </div>
        </div>
    );
}

export default ReportAndAnalyticsPage;
